import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";

import type { ReactNode } from "react";

interface DesktopFiltersToolbarProps {
  children: ReactNode;
  clearAllFilters: (() => void) | undefined;
}

export default function DesktopFiltersToolbar({
  children,
  clearAllFilters,
}: DesktopFiltersToolbarProps) {
  const hasFilters = !!clearAllFilters;

  return (
    <div className="flex gap-x-1.5 flex-1 relative py-1 justify-start items-start">
      <div className="flex gap-1.5 flex-1 flex-wrap">{children}</div>

      <RenderIf condition={hasFilters}>
        <Button
          variant="link-danger"
          size="sm"
          className="mt-1"
          onClick={clearAllFilters}
        >
          Clear all
        </Button>
        <div className="w-px h-6 bg-black-200" />
      </RenderIf>
    </div>
  );
}
